import { FontWeights, makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  header: {
    ...theme.fonts.large,
    flex: '0 1 auto',
    borderTop: `4px solid ${theme.palette.themePrimary}`,
    color: theme.palette.neutralPrimary,
    display: 'flex',
    alignItems: 'center',
    fontWeight: FontWeights.semibold,
    cursor: 'move',
    position: 'relative',
    zIndex: 99,
    backgroundColor: theme.palette.white,
    justifyContent: 'space-between',
    width: '100%',
    padding: '10px 16px',
    boxSizing: 'border-box',
  },
  title: {
    flexGrow: 1,
    fontWeight: 600,
    fontSize: '16px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  container: {
    width: '80vw',
    height: '80vh',
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
  },
  hidden: {
    width: 0,
    height: 0,
  },
  content: {
    padding: '0 10px 10px 10px',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },

  viewer: {
    width: '100%',
    height: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },

  scrollableContent: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
